import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import classnames from 'classnames';

import Languages from '../../MobileDoctorPopUp/Languages/index';
import Education from '../../MobileDoctorPopUp/Education/index';
import { doctorPropType } from '../../propTypes/index';
import styles from './profileExtras.module.css';

class ProfileExtras extends Component {
  static propTypes = {
    doctor: doctorPropType.isRequired,
    blurb: PropTypes.string.isRequired,
  };
  state = {
    showAllText: false,
  };
  readMore = () => {
    this.setState({
      showAllText: true,
    });
  };
  render() {
    return (
      <div className={styles.container}>
        <CSSTransitionGroup
          transitionName={{
            enter: styles.enter,
            enterActive: styles.enterActive,
            leave: styles.leave,
            leaveActive: styles.leaveActive,
          }}
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={1000}
        >
          <div className={styles.innerContainer}>
            <div
              className={classnames(styles.blurb, {
                [styles.fullBlurb]: this.state.showAllText,
              })}
            >
              {this.props.blurb.length > 360 && !this.state.showAllText && (
                <span className={styles.readMore}>
                  <span>...</span>
                  <span onClick={this.readMore} className={styles.readMoreText}>
                    Read more
                  </span>
                </span>
              )}
              {this.props.blurb}
            </div>
            <div className={styles.extrasContainer}>
              {this.props.doctor.Education.length ? (
                <Education education={this.props.doctor.Education} />
              ) : null}
              {this.props.doctor.Language.length ? (
                <Languages
                  languages={this.props.doctor.Language}
                  title="Languages spoken"
                />
              ) : null}
            </div>
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default ProfileExtras;
